import { CommonModule } from '@angular/common';
import { ModalBaseModule } from 'Angular/features/components/modals/modal-base/modal-base.module';
import * as i0 from "@angular/core";
export class LoadingModalModule {
}
LoadingModalModule.ɵfac = function LoadingModalModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LoadingModalModule)(); };
LoadingModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: LoadingModalModule });
LoadingModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, ModalBaseModule] });
